var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVolumeMuted = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M16.25 16.876 2.5 3.126"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.75 5.349v1.32q.001.063.046.11l.937.938a.156.156 0 0 0 .267-.11V4.71a.96.96 0 0 0-.495-.849.93.93 0 0 0-1.024.092L7.234 4.974a.156.156 0 0 0-.012.232l.666.666a.156.156 0 0 0 .21.01z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.75 14.652 5.7 12.155a1.25 1.25 0 0 0-.792-.28H2.5v-3.75h1.981a.156.156 0 0 0 .11-.267l-.937-.937a.16.16 0 0 0-.11-.046H2.188a.937.937 0 0 0-.938.938v4.375a.937.937 0 0 0 .938.937h2.724l3.57 2.922.025.02a.934.934 0 0 0 1.366-.29.96.96 0 0 0 .127-.486v-1.96a.16.16 0 0 0-.046-.11l-.937-.937a.157.157 0 0 0-.24.023.16.16 0 0 0-.027.087z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.75 10c0-.959-.227-1.87-.693-2.783a.625.625 0 0 0-1.114.567c.375.734.557 1.46.557 2.217q0 .156-.012.317a.31.31 0 0 0 .09.244l.768.769a.156.156 0 0 0 .264-.079c.093-.41.14-.83.14-1.251"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.25 10.001c0-2-.511-3.277-1.335-4.69a.625.625 0 0 0-1.08.63C14.573 7.206 15 8.276 15 10c0 .93-.129 1.675-.366 2.37a.31.31 0 0 0 .074.322l.655.655a.156.156 0 0 0 .255-.05c.4-.958.632-1.972.632-3.297"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.75 10c0-2.9-.789-4.73-1.973-6.586a.625.625 0 1 0-1.055.673C16.79 5.757 17.5 7.403 17.5 10c0 1.854-.348 3.208-.922 4.414a.16.16 0 0 0 .03.178l.697.697a.157.157 0 0 0 .25-.039c.839-1.647 1.195-3.258 1.195-5.25"
  })));
};
export { SvgVolumeMuted as ReactComponent };